export default __webpack_public_path__ + "fonts/home-1.svg";